import { __assign as o } from "./_virtual/_tslib.js";
import r, { useImperativeHandle as t } from "react";
import { useBindProp as n } from "./hooks/props.js";
import { array2Bounds as s } from "./utils/convert.js";
import { getInitialOptionsFromProps as e } from "./utils/options.js";
import i from "./hooks/component.js";
import m from "./hooks/common/custom-layer.js";
var u = r.forwardRef(function (r, u) {
  var a = i({
    init: function init(t, n) {
      var i = o(o({}, e(r)), {
        bounds: s(r.bounds)
      });
      return new t.CanvasLayer(i);
    }
  }, r);
  return t(u, function () {
    return a;
  }, [a]), m(a, r), n(a, {
    setter: function setter(o, r) {
      o.setBounds(s(r));
    },
    clone: !0
  }, r.bounds), n(a, {
    setter: "setCanvas"
  }, r.canvas), null;
});
export default u;